import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import {RouterService} from './RouterService';
import {environment} from '../environments/environment';
import {LanguageHelper} from './LanguageHelper';


declare var initScript: any;

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
    title = 'hitec-fi';
    brochureURL: string;

    selectedLanguage;
    languages;

    constructor(public router: Router, private titleService: Title, private languageHelper: LanguageHelper, public routerService: RouterService) {
        titleService.setTitle(this.title);
        this.selectedLanguage = languageHelper.getCurrentLang();
        languageHelper.setLanguage(this.selectedLanguage);
        this.brochureURL = environment.brochureURL;
        this.languages = languageHelper.getLanguages();
    }

    ngOnInit(): void {
        // tslint:disable-next-line:no-unused-expression
        new initScript();
    }

    redirect(url): void {
        this.routerService.redirect(url);
    }

    changeLanguage(language): void {
        this.languageHelper.setLanguage(language.target.value);
    }
}
